import React, { ChangeEvent } from 'react';
import moment from 'moment';

// Date picker
import DatePicker, { registerLocale } from 'react-datepicker';
import '@/assets/datepicker/datepicker.scss';

// Components
import Inputs from '@components/UI-KIT/Filters/Inputs';

// Entities
import { months, days } from '@components/UI-KIT/Inputs/DateInput';

// Icons
import { Calendar } from '@/assets/icons';

// Styles
import VARIABLES from '@/assets/variables';
import './DateFilter.scss';

interface Props {
    value: string;
    label: string;
    onChange: (_value: string) => void;
    maxDate?: string;
    minDate?: string;
}

const DateFilter: React.FC<Props> = ({
    value,
    label,
    onChange,
    maxDate,
    minDate
}) => {
    registerLocale('es', {
        localize: {
            month: (n: number) => months(false)[n],
            day: (n: number) => days[n]
        },
        formatLong: {}
    });

    const handleValue = () => {
        const date = moment(value).toDate();
        if (!date) {
            return null;
        }

        return date;
    };

    return (
        <Inputs
            className="ui-Filters-date"
            label={label}
            icon={(
                <Calendar
                    color={VARIABLES.palette.secondary_color}
                />
            )}
        >
            <DatePicker
                selected={value ? handleValue() : null}
                showMonthYearPicker={false}
                popperModifiers={{
                    preventOverflow: {
                        enabled: true // avoid attempts to stay within the view (this prevents the popper from covering the element you clicked)
                    }
                }}
                className="inputs"
                onChangeRaw={(e: ChangeEvent) => e.preventDefault()}
                onChange={(d: Date) => {
                    const date = moment(d).toDate();
                    if (!date) {
                        onChange('');
                        return;
                    }

                    onChange(date.toISOString().split('T')[0]);
                }}
                disabledKeyboardNavigation
                dateFormat="dd/MM/yyyy"
                locale="es"
                maxDate={maxDate ? moment(maxDate).toDate() : null}
                minDate={minDate ? moment(minDate).toDate() : null}
                showDisabledMonthNavigation
            />
        </Inputs>
    );
};

export default DateFilter;
